<template>
    <div>
        <div class="peribox">
            <div class="perititle">
                <div>Lead</div>
                <div class="periicons">
                    <i class="far fa-sync-alt" @click="refresh"></i>
                </div>
            </div>
            <table class="peritable">
                <tbody>
                <tr>
                    <th>Column</th>
                    <th>Lead</th>
                </tr>
                <tr v-for="c in appColumns">
                    <th>{{ c }}</th>
                    <td>{{ app ? app[c] : '' }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="peribox">
            <div class="perititle">
                <div>Custom Questions</div>
                <div class="periicons">
                    <i class="far fa-sync-alt" @click="refresh"></i>
                </div>
            </div>
            <table class="peritable">
                <tbody>
                <tr>
                    <th>Key</th>
                    <th>Readable</th>
                    <th>Value</th>
                </tr>
                <tr v-for="c in application_info">
                    <td>{{ c.key }}</td>
                    <td>{{ c.key_readable }}</td>
                    <td>{{ c.value }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'app_id'
    ],
    data() {
        let appColumns = [
            'id',
            'random_key',
            'driver_id',
            'date',
            'name',
            'first_name',
            'middle_name',
            'last_name',
            'email_redacted',
            'email_id',
            'phone_redacted',
            'phone_id',
            'zip_code',
            'cdl_a',
            'cdl_b',
            'cdl_c',
            'cdl_a_months_driven',
            'cdl_xp',
            'cdl_xp_text',
            'city',
            'state',
            'state_code',
            'location',
            'ip',
            'sms_optin',
            'timezone',
            'original_referrer',
            'entry_point',
            'paid_media_source',
            'trsource',
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'app_submit_page',
            'is_student',
            'is_xp',
            'is_direct',
            'is_mc',
            'is_sc',
            'is_jobadviser',
            'is_driverengage',
            'is_conversion',
            'is_call',
            'app_type',
            'param1',
            'param2',
            'param3',
            'call_id',
            'conversion_id',
            'app_type_delivers',
            'agent_id',
            'driver_engage_type',
            'noted_for_recruiter',
            'is_exactmatch'
        ];

        return {
            app: null,
            application_info: [],
            appColumns: appColumns
        };
    },
    methods: {
        refresh() {
            axios.get(url(`app/test/app/${this.app_id}`))
                .then((response) => {
                    this.app = response.data.app;
                    this.application_info = response.data.application_info;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>
